<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.active"
    class="fixed bottom-0 left-0 right-0 z-[9999] bg-gradient-to-r from-purple-600 to-violet-700 text-white shadow-2xl border-t border-violet-800"
    role="status"
    aria-live="polite">
    <div class="max-w-screen-2xl mx-auto flex flex-wrap items-center gap-x-4 gap-y-1 px-3 py-2 text-sm">
      <span class="flex items-center gap-2 font-semibold">
        <i class="pi pi-eye text-base"></i>
        {{ 'impersonation.bar.title' | translate }}
      </span>

      <span class="hidden sm:inline-block w-px h-4 bg-white/40"></span>

      <span class="flex items-center gap-1.5">
        <span class="opacity-80">{{ 'impersonation.bar.adminLabel' | translate }}:</span>
        <span class="font-mono font-semibold">
          {{ state.impersonatorUsername || state.impersonatorId || '—' }}
        </span>
      </span>

      <span class="hidden sm:inline-block w-px h-4 bg-white/40"></span>

      <span class="flex items-center gap-1.5">
        <i class="pi pi-arrow-right text-xs opacity-80"></i>
        <span class="opacity-80">{{ 'impersonation.bar.actingAsLabel' | translate }}:</span>
        <span class="font-mono font-semibold">
          {{ state.impersonatedUsername || state.impersonatedUserId || '—' }}
        </span>
      </span>

      <span class="flex-1"></span>

      <button type="button"
        class="inline-flex items-center gap-1.5 px-3 py-1 rounded bg-white/15 hover:bg-white/25 transition text-white text-xs font-semibold"
        (click)="logout()"
        [pTooltip]="'impersonation.bar.logoutTooltip' | translate"
        tooltipPosition="top">
        <i class="pi pi-sign-out"></i>
        <span>{{ 'impersonation.bar.logoutLabel' | translate }}</span>
      </button>
    </div>
  </div>
</ng-container>
